export const DomainName = {
  ApprovalStatement: 'ApprovalStatement',
  Department: 'Department',
  DepartmentMember: 'DepartmentMember',
  HandlingOfficer: 'HandlingOfficer',
  LeaseholdType: 'LeaseholdType',
  RecoveryType: 'RecoveryType',
  Regulation: 'Regulation',
  Reviewer: 'Reviewer',
  Status: 'Status',
  WorkMethod: 'WorkMethod',
  WorkPerformed: 'WorkPerformed',
  WorkType: 'WorkType'
};
